import { NOTIFICATION_TYPES_BY_API_TYPES } from "./constants";
export var getNotificationIconType = function getNotificationIconType(type) {
  return Object.keys(NOTIFICATION_TYPES_BY_API_TYPES).find(function (item) {
    return NOTIFICATION_TYPES_BY_API_TYPES[item].includes(type);
  });
};